import { ReactNode, useContext } from "react";
import { styled } from "styled-components";
import { CreateTransient } from "../../shared/types";
import { ExpandableSectionContext } from "./context";

type ContentProps = {
  children: ReactNode;
};

export const Content = ({ children }: ContentProps) => {
  const { isExpanded } = useContext(ExpandableSectionContext);
  return <CollapseWrapper $isExpanded={isExpanded}>{children}</CollapseWrapper>;
};

const CollapseWrapper = styled.div<CreateTransient<{ isExpanded: boolean }>>`
  overflow: hidden;
  max-height: ${({ $isExpanded }) => ($isExpanded ? "10000px" : "0")};
  transition: max-height 300ms ease-in-out;
`;
